import { render, staticRenderFns } from "./SlideTemplate.vue?vue&type=template&id=0bae247a&scoped=true&"
import script from "./SlideTemplate.vue?vue&type=script&lang=js&"
export * from "./SlideTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SlideTemplate.vue?vue&type=style&index=0&id=0bae247a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae247a",
  null
  
)

export default component.exports